module.exports = __webpack_public_path__ + "static/media/mp3-simple-icon.89f3df9f.svg";